// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Note Item Component */
note-item {
  display: block;
}

.note-item-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-left: 4px solid transparent;
  transition: all var(--transition-normal);
}

.dark .note-item-container {
  border-bottom-color: rgba(255, 255, 255, 0.05);
}

.note-item-container:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.dark .note-item-container:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.note-item-container.selected {
  background-color: var(--btn-active-bg);
  border-left-color: var(--text-muted);
}

.note-item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.note-item-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.note-item-date {
  font-size: 0.75rem;
  color: var(--text-muted);
  font-weight: 500;
  white-space: nowrap;
  margin-left: 0.5rem;
}

.note-item-body {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-muted);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.note-item-actions {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  opacity: 0;
  transition: opacity 0.2s;
}

.note-item-container:hover .note-item-actions {
  opacity: 1;
}

.note-item-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border: none;
  border-radius: 0.25rem;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: all var(--transition-normal);
}

.note-item-action-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: var(--text-primary);
}

.dark .note-item-action-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Note List Component */
note-list {
  display: block;
}

.note-list-container {
  flex: 1;
  overflow-y: auto;
}

.mobile-note-list-container {
  padding: 0 1.25rem 6.5rem;
}

.note-list-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
}

.note-list-grid.mobile {
  gap: 1rem;
}

.note-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
}

.note-list-empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.note-list-empty-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--text-primary);
}

.note-list-empty-text {
  font-size: 0.875rem;
  margin: 0;
}

/* Mobile card style */
.note-list-mobile-card {
  background-color: var(--bg-card);
  border-radius: 0.75rem;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all var(--transition-normal);
}

.note-list-mobile-card:active {
  transform: scale(0.98);
}

.note-list-mobile-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
}

.note-list-mobile-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.4;
}

.note-list-mobile-card-date {
  font-size: 0.75rem;
  color: var(--text-muted);
  font-weight: 500;
}

.note-list-mobile-card-body {
  font-size: 0.875rem;
  color: var(--text-muted);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/note-list.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,4CAA4C;EAC5C,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,wCAAwC;EACxC,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX","sourcesContent":["/* Note Item Component */\nnote-item {\n  display: block;\n}\n\n.note-item-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 1rem;\n  cursor: pointer;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  border-left: 4px solid transparent;\n  transition: all var(--transition-normal);\n}\n\n.dark .note-item-container {\n  border-bottom-color: rgba(255, 255, 255, 0.05);\n}\n\n.note-item-container:hover {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n\n.dark .note-item-container:hover {\n  background-color: rgba(255, 255, 255, 0.03);\n}\n\n.note-item-container.selected {\n  background-color: var(--btn-active-bg);\n  border-left-color: var(--text-muted);\n}\n\n.note-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.note-item-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1;\n}\n\n.note-item-date {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  font-weight: 500;\n  white-space: nowrap;\n  margin-left: 0.5rem;\n}\n\n.note-item-body {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.note-item-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.note-item-container:hover .note-item-actions {\n  opacity: 1;\n}\n\n.note-item-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border: none;\n  border-radius: 0.25rem;\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.note-item-action-btn:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: var(--text-primary);\n}\n\n.dark .note-item-action-btn:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Note List Component */\nnote-list {\n  display: block;\n}\n\n.note-list-container {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.mobile-note-list-container {\n  padding: 0 1.25rem 6.5rem;\n}\n\n.note-list-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0;\n}\n\n.note-list-grid.mobile {\n  gap: 1rem;\n}\n\n.note-list-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.note-list-empty-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.note-list-empty-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin: 0 0 0.5rem 0;\n  color: var(--text-primary);\n}\n\n.note-list-empty-text {\n  font-size: 0.875rem;\n  margin: 0;\n}\n\n/* Mobile card style */\n.note-list-mobile-card {\n  background-color: var(--bg-card);\n  border-radius: 0.75rem;\n  padding: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n}\n\n.note-list-mobile-card:active {\n  transform: scale(0.98);\n}\n\n.note-list-mobile-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n}\n\n.note-list-mobile-card-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n  line-height: 1.4;\n}\n\n.note-list-mobile-card-date {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.note-list-mobile-card-body {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
